module.exports = __webpack_public_path__ + "static/media/icon-time.e8d28ac6.svg";